unit App.Web.Utils;

interface

uses
  App.Enumerations;

type

  TAppUtils = class
  public

  end;

implementation

uses
  System.SysUtils,
  Rtti;

end.
